import type * as Types from 'app/types/graphql';

import {
  ArticleEdgeSelectFragmentDoc,
  ArticleSelectFragmentDoc,
} from '../fragments/articles.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ArticlesQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  before?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  orderBy?: Types.InputMaybe<Types.ArticleOrder>;
  where?: Types.InputMaybe<Types.ArticleWhereInput>;
}>;

export type ArticlesQueryResponse = {
  articles?: Types.Maybe<{
    edges: Array<{
      node?: Types.Maybe<
        Pick<Types.Article, 'baseID' | 'title' | 'handle' | 'publishedAt' | 'templateSuffix'> & {
          blogs?: Types.Maybe<{
            edges: Array<{ node?: Types.Maybe<Pick<Types.Blog, 'handle' | 'baseID'>> }>;
          }>;
          media?: Types.Maybe<Pick<Types.Media, 'src'>>;
        }
      >;
    }>;
    pageInfo?: Types.Maybe<Pick<Types.PageInfo, 'hasNextPage' | 'endCursor'>>;
  }>;
};

export const ArticlesDocument = `
    query Articles($after: Cursor, $before: Cursor, $first: Int, $last: Int, $orderBy: ArticleOrder, $where: ArticleWhereInput) {
  articles(
    after: $after
    before: $before
    first: $first
    last: $last
    orderBy: $orderBy
    where: $where
  ) {
    edges {
      ...ArticleEdgeSelect
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${ArticleEdgeSelectFragmentDoc}
${ArticleSelectFragmentDoc}`;

export const useArticlesQuery = <TData = ArticlesQueryResponse, TError = unknown>(
  variables?: ArticlesQueryVariables,
  options?: UseQueryOptions<ArticlesQueryResponse, TError, TData>,
) => {
  return useQuery<ArticlesQueryResponse, TError, TData>(
    variables === undefined ? ['Articles'] : ['Articles', variables],
    appFetcher<ArticlesQueryResponse, ArticlesQueryVariables>(ArticlesDocument, variables),
    options,
  );
};

useArticlesQuery.getKey = (variables?: ArticlesQueryVariables) =>
  variables === undefined ? ['Articles'] : ['Articles', variables];
